export default "__VITE_ASSET__4b760fb4__"